var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStarIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.54127 1.05787C8.71535 0.656427 9.28465 0.656426 9.45873 1.05787L11.5981 5.99152C11.6706 6.15859 11.8281 6.27307 12.0094 6.29034L17.3627 6.80045C17.7983 6.84196 17.9742 7.38339 17.6462 7.673L13.6152 11.2323C13.4786 11.3528 13.4185 11.538 13.4581 11.7158L14.6272 16.9647C14.7223 17.3918 14.2617 17.7264 13.8849 17.504L9.2542 14.7701C9.09738 14.6775 8.90262 14.6775 8.7458 14.7701L4.11506 17.504C3.73827 17.7264 3.2777 17.3918 3.37283 16.9647L4.54194 11.7158C4.58153 11.538 4.52135 11.3528 4.38484 11.2323L0.353771 7.673C0.0257726 7.38339 0.201695 6.84196 0.63728 6.80045L5.99057 6.29034C6.17186 6.27307 6.32942 6.15859 6.40187 5.99152L8.54127 1.05787Z",
    fill: "#F7AD01"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarIcon);
export default __webpack_public_path__ + "static/media/starIcon.87aa6b6dd12d4e5282fe198b755c0ffb.svg";
export { ForwardRef as ReactComponent };